import {i18n} from '@yourcoach/i18n';

import type {ProgramPaymentOption} from './types';

interface ProgramPaymentOptionEnum {
  CUSTOM: ProgramPaymentOption;
  FREE: ProgramPaymentOption;
}

export const ProgramPaymentOptionEnum: ProgramPaymentOptionEnum = {
  CUSTOM: {
    id: 'custom',
  },
  FREE: {
    id: 'free',
  },
};

Object.keys(ProgramPaymentOptionEnum).forEach(key => {
  const type: ProgramPaymentOption = ProgramPaymentOptionEnum[key];

  type.toString = () =>
    /**
     * @i18n_parser
     * t('shared:program.payment_option.custom')
     * t('shared:program.payment_option.free')
     */
    i18n.t(`shared:program.payment_option.${type.id}`);
});
